import ModalTypes from '../enums/app/modalTypes';
import {hideModalAction} from '../state/ducks/modal';
import {makeSelectVisibleGlobalModal} from '../state/selectors/modal';
import {dispatch, getState} from '../state/store';

const hideModal = (modalType: ModalTypes): void => {
    const modal = makeSelectVisibleGlobalModal(modalType)(getState());

    if (modal) {
        dispatch(hideModalAction(modalType));
    }
};

export default {hideModal};
